module.exports = new __parcel__URL__("beetlejuice-jeffrey-jones.514d98de.gif").toString();